import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  rentalTags() {
    return Api()
      .get('/rentaltags', {})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  rentalTag(id) {
    return Api()
      .get('/rentaltag/' + id)
      .then((res) => this.formatRes(res.data));
  },
  create(rentaltag) {
    return Api()
      .post('/rentaltag', rentaltag)
      .then((res) => this.formatRes(res.data));
  },
  update(rentaltag) {
    return Api()
      .put('/rentaltag/' + rentaltag.id, rentaltag)
      .then((res) => this.formatRes(res.data));
  },
  init() {
    return Api().post('/rentaltags/init', {timeout: 600000});
  },
  formatRes(e) {
    return e;
  },
};
